import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TaskListCalendarImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TaskListCalendarImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const TaskListCalendarImage = (t0)=>{
    const $ = c(53);
    let props;
    if ($[0] !== t0) {
        props = _extends({}, t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M4 16C4 11.5817 7.58172 8 12 8H52C56.4183 8 60 11.5817 60 16V64H4V16Z",
            fill: "white"
        });
        $[2] = t1;
    } else t1 = $[2];
    const t2 = `url(#paint0_${props.id})`;
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M59 16C59 12.134 55.866 9 52 9H12C8.13401 9 5 12.134 5 16V63H59V16ZM60 64H4V16C4 11.5817 7.58172 8 12 8H52C56.4183 8 60 11.5817 60 16V64Z",
            fill: t2
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = `url(#paint1_${props.id})`;
    let t5;
    if ($[5] !== t4) {
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M18 5C18 2.23858 20.2386 0 23 0C25.7614 0 28 2.23858 28 5V11C28 13.7614 25.7614 16 23 16C20.2386 16 18 13.7614 18 11V5Z",
            fill: t4
        });
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = `url(#paint2_${props.id})`;
    let t7;
    if ($[7] !== t6) {
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M36 5C36 2.23858 38.2386 0 41 0C43.7614 0 46 2.23858 46 5V11C46 13.7614 43.7614 16 41 16C38.2386 16 36 13.7614 36 11V5Z",
            fill: t6
        });
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    const t8 = `url(#paint3_${props.id})`;
    let t9;
    if ($[9] !== t8) {
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M11 24.5C11 23.1193 12.1193 22 13.5 22H39.5C40.8807 22 42 23.1193 42 24.5C42 25.8807 40.8807 27 39.5 27H13.5C12.1193 27 11 25.8807 11 24.5Z",
            fill: t8
        });
        $[9] = t8;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = `url(#paint4_${props.id})`;
    let t11;
    if ($[11] !== t10) {
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M26 33.5C26 32.1193 27.1193 31 28.5 31H50.5C51.8807 31 53 32.1193 53 33.5C53 34.8807 51.8807 36 50.5 36H28.5C27.1193 36 26 34.8807 26 33.5Z",
            fill: t10
        });
        $[11] = t10;
        $[12] = t11;
    } else t11 = $[12];
    let t12;
    if ($[13] !== t11 || $[14] !== t3 || $[15] !== t5 || $[16] !== t7 || $[17] !== t9) {
        t12 = /*#__PURE__*/ jsx("g", {
            children: /*#__PURE__*/ jsxs("g", {
                children: [
                    t1,
                    t3,
                    t5,
                    t7,
                    t9,
                    t11
                ]
            })
        });
        $[13] = t11;
        $[14] = t3;
        $[15] = t5;
        $[16] = t7;
        $[17] = t9;
        $[18] = t12;
    } else t12 = $[18];
    const t13 = `paint0_${props.id}`;
    let t14;
    let t15;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ jsx("stop", {
            stopColor: "currentColor"
        });
        t15 = /*#__PURE__*/ jsx("stop", {
            offset: "0.780666",
            stopColor: "white"
        });
        $[19] = t14;
        $[20] = t15;
    } else {
        t14 = $[19];
        t15 = $[20];
    }
    let t16;
    if ($[21] !== t13) {
        t16 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t13,
            x1: "40",
            y1: "-14.5",
            x2: "18.5",
            y2: "67.5",
            gradientUnits: "userSpaceOnUse",
            children: [
                t14,
                t15
            ]
        });
        $[21] = t13;
        $[22] = t16;
    } else t16 = $[22];
    const t17 = `paint1_${props.id}`;
    let t18;
    let t19;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t19 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[23] = t18;
        $[24] = t19;
    } else {
        t18 = $[23];
        t19 = $[24];
    }
    let t20;
    if ($[25] !== t17) {
        t20 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t17,
            x1: "23",
            y1: "0",
            x2: "23",
            y2: "16",
            gradientUnits: "userSpaceOnUse",
            children: [
                t18,
                t19
            ]
        });
        $[25] = t17;
        $[26] = t20;
    } else t20 = $[26];
    const t21 = `paint2_${props.id}`;
    let t22;
    let t23;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t23 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[27] = t22;
        $[28] = t23;
    } else {
        t22 = $[27];
        t23 = $[28];
    }
    let t24;
    if ($[29] !== t21) {
        t24 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t21,
            x1: "41",
            y1: "0",
            x2: "41",
            y2: "16",
            gradientUnits: "userSpaceOnUse",
            children: [
                t22,
                t23
            ]
        });
        $[29] = t21;
        $[30] = t24;
    } else t24 = $[30];
    const t25 = `paint3_${props.id}`;
    let t26;
    let t27;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t26 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t27 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[31] = t26;
        $[32] = t27;
    } else {
        t26 = $[31];
        t27 = $[32];
    }
    let t28;
    if ($[33] !== t25) {
        t28 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t25,
            x1: "26.5",
            y1: "22",
            x2: "26.5",
            y2: "27",
            gradientUnits: "userSpaceOnUse",
            children: [
                t26,
                t27
            ]
        });
        $[33] = t25;
        $[34] = t28;
    } else t28 = $[34];
    const t29 = `paint4_${props.id}`;
    let t30;
    let t31;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t30 = /*#__PURE__*/ jsx("stop", {
            stopColor: "white"
        });
        t31 = /*#__PURE__*/ jsx("stop", {
            offset: "1",
            stopColor: "currentColor"
        });
        $[35] = t30;
        $[36] = t31;
    } else {
        t30 = $[35];
        t31 = $[36];
    }
    let t32;
    if ($[37] !== t29) {
        t32 = /*#__PURE__*/ jsxs("linearGradient", {
            id: t29,
            x1: "39.5",
            y1: "31",
            x2: "39.5",
            y2: "36",
            gradientUnits: "userSpaceOnUse",
            children: [
                t30,
                t31
            ]
        });
        $[37] = t29;
        $[38] = t32;
    } else t32 = $[38];
    const t33 = `clip0_${props.id}`;
    let t34;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ jsx("rect", {
            width: "64",
            height: "60",
            fill: "white"
        });
        $[39] = t34;
    } else t34 = $[39];
    let t35;
    if ($[40] !== t33) {
        t35 = /*#__PURE__*/ jsx("clipPath", {
            id: t33,
            children: t34
        });
        $[40] = t33;
        $[41] = t35;
    } else t35 = $[41];
    let t36;
    if ($[42] !== t16 || $[43] !== t20 || $[44] !== t24 || $[45] !== t28 || $[46] !== t32 || $[47] !== t35) {
        t36 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t16,
                t20,
                t24,
                t28,
                t32,
                t35
            ]
        });
        $[42] = t16;
        $[43] = t20;
        $[44] = t24;
        $[45] = t28;
        $[46] = t32;
        $[47] = t35;
        $[48] = t36;
    } else t36 = $[48];
    let t37;
    if ($[49] !== props || $[50] !== t12 || $[51] !== t36) {
        t37 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({
            width: "64",
            height: "60",
            viewBox: "0 0 64 60",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, props), {
            children: [
                t12,
                t36
            ]
        }));
        $[49] = props;
        $[50] = t12;
        $[51] = t36;
        $[52] = t37;
    } else t37 = $[52];
    return t37;
};
export { TaskListCalendarImage };
